import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'react-bootstrap'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * suffix to avoid conflicts with checkboxes from other forms with the same id
   * used for the id of the checkbox html element (doesn't affect formik id)
   */
  idSuffix: PropTypes.string,
  /**
   * If exists, calls it with the value for custom additional actions
   * Formik setFieldValue will always run before it
   */
  onChange: PropTypes.func,
}

/**
 * Handles a checkbox with Formik for TOGGLE (boolean) use
 */
function FormikToggleCheckbox(props) {
  const { id, idSuffix = '', onChange = null, ...rest } = props ?? {}

  return (
    <Field name={id}>
      {({ field }) => {
        const isChecked = field.value === true
        return (
          <Form.Check
            {...rest}
            custom
            type="checkbox"
            id={`${id}${idSuffix}`}
            name={id}
            value={isChecked}
            checked={isChecked}
            onChange={(event) => {
              field.onChange(event)
              if (onChange) {
                onChange(event.target.checked)
              }
            }}
          />
        )
      }}
    </Field>
  )
}

FormikToggleCheckbox.propTypes = propTypes

export default FormikToggleCheckbox
